import { mapGetters } from 'vuex'
var collectorMixin = {
  computed: {
    ...mapGetters(['collectors'])
  },
  methods: {
    getCollectorName (collector_id) {
      if (this.collectors.length) {
        const index = this.collectors.findIndex((e) => e.entity_id == collector_id)
        return index > -1 ? this.collectors[index].name : null
      }
      return null
    },
    getDrivesName (collector_id) {
      if (this.collectors.length) {
        const index = this.collectors.findIndex((e) => e.entity_id == collector_id)
        return (index > -1 && this.collectors[index].drivesName) ? this.collectors[index].drivesName : {}
      }
      return {}
    }
  }
}

export default collectorMixin
